import { SignoutComponent } from './standalone/signout/signout.component';
import { inject, NgModule } from '@angular/core';
import { RedirectFunction, Router, Routes, RouterModule } from '@angular/router';
import { ViewsGuard } from './views/views.guard';
import { LoadComponent } from './standalone/load/load.component';
import { PreJoinComponent } from './standalone/pre-join/pre-join.component';
import { ClearCacheComponent } from './standalone/clear-cache/clear.component';
import { ReloadCacheComponent } from './standalone/reload-cache/reload-cache.component';
import { CallbackComponent } from './auth/callback/callback.component';

const redirectToAuthRoute = (...commands: string[]): RedirectFunction =>
  ({ queryParams, fragment }) => inject(Router).createUrlTree(
    ['/auth', ...commands],
    { queryParams, fragment },
  );

export const APP_ROUTES: Routes = [
  {
    path: 'super/callback',
    pathMatch: 'full',
    data: [],
    redirectTo: redirectToAuthRoute('super', 'callback'),
  },
  {
    path: 'super',
    pathMatch: 'full',
    redirectTo: redirectToAuthRoute('super'),
  },
  {
    path: 'auth/callback',
    component: CallbackComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [ViewsGuard],
    loadChildren: () => import('./views/views.module').then(m => m.ViewsModule)
  },
  {
    path: 'signout',
    component: SignoutComponent,
  },
  {
    path: 'clear-cache',
    component: ClearCacheComponent,
  },
  {
    path: 'reload-cache',
    component: ReloadCacheComponent,
  },
  {
    path: 'load',
    component: LoadComponent,
  },
  {
    path: 'pre-join',
    component: PreJoinComponent,
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
